if($('.gs__cart-page1 > .gs__row').length && (__st.cid == undefined)) {
  $('.gs__cart-page1 > .gs__row:first-child').append('<div class="li-callout"><strong>NOTE: To select from your address book, please <a href="https://bridgewater-chocolate.myshopify.com/account/login?return_url=%2Fa%2Fgs%2Fcart%2F">Log In</a></strong></div>');
}

$('.reviews-home').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
});

$('.ctr-right').click(function(){
  $(".reviews-home").slick("slickNext");
});

$('.ctr-left').click(function(){
  $(".reviews-home").slick("slickPrev");
});


$(window).scroll(function (event) {
  if($(window).scrollTop() <= 80) {
      $("#shopify-section-header").removeClass("show-topbar");
  } else {
    $("#shopify-section-header").addClass("show-topbar");
  }
});




$readMoreJS.init({
target: '.corporate-texts p', // Selector of the element the plugin applies to (any CSS selector, eg: '#', '.'). Default: ''
numOfWords: 25,               // Number of words to initially display (any number). Default: 50
toggle: true,                 // If true, user can toggle between 'read more' and 'read less'. Default: true
moreLink: 'READ MORE',    // The text of 'Read more' link. Default: 'read more ...'
lessLink: 'READ LESS'         // The text of 'Read less' link. Default: 'read less'
});

$('#detail-header-bar .detail-header').click(function(){
$("#detail-header-bar .detail-text").toggleClass("showdetail");
});
$('#allergens-header-bar .detail-header').click(function(){
$("#allergens-header-bar .detail-text").toggleClass("showdetail");
});


$(".site-footer__item-inner li a").on("click", function() {
linkAttr = $(this).attr("href");

if( linkAttr == "#wrapper-contact"){
  $("#wrapper-contact").toggleClass("opened");
  setTimeout( function() { gobottom(); }, 250);
  
}

});

function gobottom(){
window.scrollTo(0,document.body.scrollHeight);
}

$('.close-contact').click(function(){
$("#wrapper-contact").toggleClass("opened");
});

$('.product-option-lists li input').click(function(){
var target = $(this).data("chtype");
var singleoptionselector = $(this).data("singleoptionselector");

$("#"+singleoptionselector + " option").each(function () {

  $(this).removeAttr("selected");

  if ( $(this).val() == target ) {

    $(this).attr("selected", "selected");

  }

});

//console.log( singleoptionselector );

//$("#"+singleoptionselector).val(target).trigger('change');

//$("#inputBillingcycle").val(value).trigger('change');

/*
$(".product-variants ul li").removeClass("ShowOption");
$(".product-variants ul li.va-"+target).addClass("ShowOption");
*/
});

$('.js-load-more').on('click', function(){
var $this =$(this),
totalPages = parseInt($('[data-all-pages]').val()), 
currentPage = parseInt($('[data-this-page]').val()),
datacollurl = $('[data-coll-url]').val();;
$this.attr('disabled', true);
$this.find('[load-more-text]').addClass('hide');
$this.find('[loader]').removeClass('hide');
var nextUrl = $('[data-next-link]').val();
var current_page_new = currentPage + 1;
var next_coll = currentPage + 2;
//alert(current_page_new)
//return false;
$.ajax({
  url: nextUrl,
  type: 'GET',
  dataType: 'html',
  success: function(responseHTML){
    $('[data-next-link]').val(datacollurl + "?page="+next_coll);
    $('[data-this-page]').val(current_page_new);
    $('.grid--view-items').append($(responseHTML).find('.grid--view-items').html());
    console.log("total " + totalPages);
  },
  complete: function() {
  if(current_page_new < totalPages) {
    $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
  } 
  if(current_page_new >= totalPages) {
    $this.find('[load-more-text]').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
  } 
  }
})
});

/***** FILTERS *****/

/** GET Collection Name **/

var current_url_complete = $(location).attr('pathname');
var collection_url = current_url_complete.split('/');
var current_path = collection_url[collection_url.length-2]
var current_collection = collection_url[collection_url.length-1];

var JSONarray = [];
var FilteredArray = [];
var SelectedTags = [];


function loadAllProducts(){
JSONarray = [];
$.ajax({
  url: "/collections/"+current_collection+"/products.json?limit=250",
  success: function(response)
  {
    console.log("ALL DATA");
    item = {};

    for(var i =0; i < response.products.length;i++){

      for(var j =0; j < response.products[i].images.length; j++){
        if( j == 0){
          bgrImage = response.products[i].images[j].src;
        }
      }
      if( bgrImage == "" ){
        bgrImage = "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
      }
      current_priceMax = 0;
      current_priceMin = 0;
      var rangeFullPrices = [];
      for(var j =0; j < response.products[i].variants.length; j++){
        current_priceMax = parseFloat(response.products[i].variants[0].price);
        current_priceMin = parseFloat(response.products[i].variants[0].price);
        if( response.products[i].variants[j].price > current_priceMax ) current_priceMax = response.products[i].variants[j].price;
        if( response.products[i].variants[j].price < current_priceMin ) current_priceMin = response.products[i].variants[j].price;

        if(response.products[i].variants[j].price < 15 ) rangeFullPrices.push("r1");
        if(response.products[i].variants[j].price >= 15 && response.products[i].variants[j].price < 30) rangeFullPrices.push("r2");
        if(response.products[i].variants[j].price >= 30 && response.products[i].variants[j].price < 50) rangeFullPrices.push("r3");
        if(response.products[i].variants[j].price >= 50 && response.products[i].variants[j].price < 100) rangeFullPrices.push("r4");
        if(response.products[i].variants[j].price >= 100 ) rangeFullPrices.push("r5");
      }

      var rPrice = rangeFullPrices.filter(function(element,index,self){
        return index === self.indexOf(element); 
      });

      JSONarray.push({
        id: response.products[i].id,
        title: response.products[i].title,
        imageBgr: bgrImage,
        priceMin: current_priceMin,
        priceMax: current_priceMax,
        url: response.products[i].handle,
        tags: response.products[i].tags.concat(rPrice)
      });
    }
    //console.log( JSONarray );
    fillGrid( JSONarray );
    $('.filterbox-list ul li input').prop('checked', false);
  }
});
console.log( JSONarray ) ;
}

var filterArray = [], currentFilter = "",  filterPriceArray = [];

$('.filterbox-list ul li input').change(function() {
currentFilter = $(this).val();

if(this.checked) {
  $(this).prop("checked");
  filterArray.push(currentFilter);
}
else{
  for( var i = 0; i < filterArray.length; i++){ 
    if ( filterArray[i] === currentFilter ) { 
      filterArray.splice(i, 1); 
    }
  }
}
if( filterArray === undefined || filterArray.length == 0 ){
  loadAllProducts();
}else{
  filtering( filterArray );
}
});

function filtering( filtervar ){
FilteredArray = [];
SelectedTags = [];

for(var i =0; i < JSONarray.length;i++){

  for(var k =0; k < JSONarray[i].tags.length; k++){

    for( var z = 0; z < filtervar.length ; z++ ){
      console.log( filtervar[z].toLowerCase() +" and " + JSONarray[i].tags[k].toLowerCase() );
      if( filtervar[z].toLowerCase() == handleize(JSONarray[i].tags[k]) ){

        FilteredArray.push({
          id: JSONarray[i].id,
          title: JSONarray[i].title,
          imageBgr: JSONarray[i].imageBgr,
          priceMin: JSONarray[i].priceMax,
          priceMax: JSONarray[i].priceMin,
          url: JSONarray[i].url,
          tags: JSONarray[i].tags
        });

      }

    }

  }

}
var clearedFilter = FilteredArray.filter(function(element,index,self){
  return index === self.indexOf(element); 
});

var clearedFilter = FilteredArray.filter((FilteredArray, index, self) => index === self.findIndex((t) => (t.id === FilteredArray.id)));

fillGrid( clearedFilter );
console.log("HERE");
console.log( clearedFilter );
}

function fillGrid( fillArray ){

var grid = " ";
var nineLimit = 1, groupGrid = 1, currentGroup = 1;

$(".grid--view-items").html("");

for( var i = 0; i < fillArray.length; i++){
  minPriceShow =  fillArray[i].priceMin;
  if ( fillArray[i].priceMin > fillArray[i].priceMax ) minPriceShow = fillArray[i].priceMax; 
  if( groupGrid == 1 ) showGrid = "show-grid-group"; else { showGrid = "" }
  grid += '<li class="grid__item grid__item--collection-grid group-'+ groupGrid +' '+ showGrid +'" > <a href="/products/'+ fillArray[i].url +'" class="grid_item_image" style="background-image: url('+ fillArray[i].imageBgr +')" ></a> <a href="/products/'+ fillArray[i].url +'" class="grid-product-title"> '+ fillArray[i].title +' </a> <span>from $'+ minPriceShow +'</span> </li>';
  nineLimit++;
}
$( ".grid--view-items" ).html( grid );
if( nineLimit > 9 ){
  groupGrid++;
  nineLimit = 1;
}
}



if (window.performance) {
var navEntries = window.performance.getEntriesByType('navigation');
if (navEntries.length > 0 && navEntries[0].type === 'back_forward') {
     //console.log('As per API lv2, this page is load from back/forward');
     if( collection_url[collection_url.length-2] == "collections")
     {
      location.reload();
     }
} else if (window.performance.navigation
     && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
     //console.log('As per API lv1, this page is load from back/forward');
} else {
     //console.log('This is normal page load');
}
} else {
//console.log("Unfortunately, your browser doesn't support this API");
}
var cartItemKey;
var toText;
var fromText;
var mssgText;
var qttyBox=0;

$(document).ready(function() {

//sendFilter('all');

if (!document.body.classList.contains('template-index')) {
  loadAllProducts();
}
/*
$('.updateCartBtn').on('click', function(){
  console.log("ok");
  var cartItemKey = $(this).data("cky");

  var toText = $('[data-grky="'+cartItemKey+'"] li .fieldTo').val();
  var fromText = $('[data-grky="'+cartItemKey+'"] li .fieldFrom').val();
  var mssgText = $('[data-grky="'+cartItemKey+'"] li .fieldMessage').val();

  jQuery.post('/cart/change.js', { properties: { gift:"yes", To: toText, From: fromText, Message: mssgText}, id: cartItemKey });

  setInterval(function()
  {
    location.reload();
  }, 1000);
});
*/

$('.updateCartBtn').on('click', function(){

  modalToText = $('.fieldToModal').val();
  modalFromText = $('.fieldFromModal').val();
  modalMssgText = $('.fieldMessageModal').val();
  modalQtty = $('.fieldQtty').val();

  jQuery.post('/cart/change.js', { properties: { gift:"yes", To: modalToText, From: modalFromText, Message: modalMssgText}, id: cartItemKey, quantity: modalQtty });

  setInterval(function()
  {
    location.reload();
  }, 1000);

});


$('.note-cartbox').on('click', function(){
  console.log("modal open");
  cartItemKey = $(this).data("grky");

  console.log(cartItemKey);
  toText = $('[data-grky="'+cartItemKey+'"] li .fieldTo').val();
  fromText = $('[data-grky="'+cartItemKey+'"] li .fieldFrom').val();
  mssgText = $('[data-grky="'+cartItemKey+'"] li .fieldMessage').val();

  qttyBox = $('[data-cart-item-key="'+cartItemKey+'"] .cart__qty-input').val();

  //console.log("qtty" + qttyBox ); 

  $(".popup-message-overlay").addClass("show-dialog");

  if( toText ){ $(".fieldToModal").val(toText); } else  $(".fieldToModal").val("");
  if( fromText ){ $(".fieldFromModal").val(fromText); } else $(".fieldFromModal").val("");
  if( mssgText ){ $(".fieldMessageModal").val(mssgText); } else $(".fieldMessageModal").val("");
  $(".fieldQtty").val(qttyBox);
});




$('.gs__close-modal').on('click', function(){
  closeModalMssg();
});


function closeModalMssg(){
  $(".popup-message-overlay").removeClass("show-dialog");
}


//note-cartbox

$('.delCartBtn').on('click', function(){

  var cartItemKey = $(this).data("cky");

  jQuery.post('/cart/change.js', { quantity: 0, id: cartItemKey });

  setInterval(function()
  {
    location.reload();
  }, 1000);
});


var selectedVal = "";
var selected = $(".bow-select-box input[type='radio']:checked");
if (selected.length > 0) {
  selectedVal = selected.val();
  if( selectedVal == "yes" ){
    $(".bowl-box-wrapper input[type=checkbox]").attr('checked', true);
  }
}
});

$(window).load(function() {
  $( ".product-option-lists li:nth-child(1) input" ).trigger( "click" );
  $(".home-grid-0").addClass("show-home-grid");
  $(".bowl-box-wrapper input[type=checkbox]").attr('checked', true);
});



$('#grid-nav li a').on('click', function(){
var gridSection = $(this).data("grid");
$(".home-grid").removeClass("show-home-grid");
$(".home-grid-"+gridSection).addClass("show-home-grid");

$(".side-nav #grid-nav li a").removeClass("active");
$(".side-nav #grid-nav li:nth-child("+ ( gridSection + 1 ) + ") a").addClass("active");

});


$('.header-btn-search').on('click', function(){
$("predictive-search").toggleClass("show-search");
});


$('.apply-filter-btn').click( function() {
var allFilters = '';
var $activeFilters = $('.filter_checkbox:checked');
var activeFiltersCount = $activeFilters.length;
var lastActiveFilterIndex = activeFiltersCount - 1;
$activeFilters.each(function (index) {
  var filterValue = $(this).val(); // the tag
  allFilters += filterValue; // append the tag to our filters
  // To use multiple filters at once you must separate them with a + (plus)
  if (index !== lastActiveFilterIndex) {
    allFilters += '+';
  }
});

// Append filters to the base URL and redirect the user to the new URL
var newUrl = window.location.pathname + '/' + allFilters;
window.location = newUrl;
});

$(".header-btn-menu").on('touchstart', function() {
  $(".nav-items").toggleClass("show-mobile-menu");
});

$("ul.parent.nav-items > li:first-child > .arrowbtn").on('touchstart', function() {
  $("ul.parent.nav-items > li:nth-child(2) .sub-menu__wrapper").removeClass("sub-open-mobile");
  $("ul.parent.nav-items > li:first-child .sub-menu__wrapper").toggleClass("sub-open-mobile");
});

$("ul.parent.nav-items > li:nth-child(2) > .arrowbtn").on('touchstart', function() {
  $("ul.parent.nav-items > li:nth-child(1) .sub-menu__wrapper").removeClass("sub-open-mobile");
  $("ul.parent.nav-items > li:nth-child(2) .sub-menu__wrapper").toggleClass("sub-open-mobile");
});


// menu 1
$("ul.parent.nav-items > li:first-child .child  > li:first-child :not(a)").on('touchstart', function() {
  $("ul.parent.nav-items > li:first-child .child  > li:nth-child(2) .grandchild").removeClass("grand-open-mobile");
  $("ul.parent.nav-items > li:first-child .sub-menu__wrapper").removeClass("sub-open-plus-two");

  $("ul.parent.nav-items > li:first-child .sub-menu__wrapper").toggleClass("sub-open-plus-one");
  $("ul.parent.nav-items > li:first-child .child  > li:first-child .grandchild").toggleClass("grand-open-mobile");

//sub-open-mobile.sub-open-plus-one

});


// menu 2
$("ul.parent.nav-items > li:first-child .child  > li:nth-child(2) :not(a)").on('touchstart', function() {
  $("ul.parent.nav-items > li:first-child .child  > li:first-child .grandchild").removeClass("grand-open-mobile");
  $("ul.parent.nav-items > li:first-child .sub-menu__wrapper").removeClass("sub-open-plus-one");

  $("ul.parent.nav-items > li:first-child .sub-menu__wrapper").toggleClass("sub-open-plus-two");
  $("ul.parent.nav-items > li:first-child .child  > li:nth-child(2) .grandchild").toggleClass("grand-open-mobile");

});

function changeGridGroup( variantId ){
$(".wrapper-inside-grid").removeClass("show-inside-grid");
$(".wrapper-inside-grid.variantId-"+variantId).addClass("show-inside-grid");
//wrapper-inside-grid variantId-41012706148519  show-inside-grid
}


$("#bowl-option-selector").change(function() {
if(this.checked) {
  //console.log("SELECTED");
  $("fieldset .bow-select-box:nth-child(2) input").trigger("click");
}
else{
  //console.log("NO SELECTED");
  $("fieldset .bow-select-box:nth-child(1) input").trigger("click");
}
});

var current_data_qty;

$(".cart__qty-input").focusin(function() {
  current_data_qty = $(this).val();
});


$(".cart__qty-input").focusout(function() {
  var data_device = $(this).attr("data-role");
  var data_id = $(this).attr("id");
  var data_id_arry = data_id.split("_");
  var data_id_key = data_id_arry[2];
  var data_qty = $(this).val();

  if( current_data_qty != data_qty ){
    //console.log("cart device " + data_device + " id: " + data_id_key + " value: "+ data_qty + " current qty: " + current_data_qty);

    var data = {
      quantity: data_qty,
      id: data_id_key
    }
  
    jQuery.ajax({
      type: 'post',
      url: '/cart/change.js',
      data: data,
      success: function(d){
        //console.log(d);
        location.reload();
      },
      dataType: 'json'
    });
  }

});


function updateQtty(){
//jQuery.post('/cart/change.js', { id: cartItemKey, quantity : 10 });
var newQtty = $("#quantity-popup").val();
var currrentCartKey = $("#cart-key").val();

var data = {
  quantity: newQtty,
  id: currrentCartKey
}
jQuery.ajax({
  type: 'post',
  url: '/cart/change.js',
  data: data,
  success: function(d){
    $(".save_qt-popup_btn span").fadeIn();
    setTimeout( function() { $(".save_qt-popup_btn span").fadeOut(); }, 1500);
    //console.log(d);
    var freeShippingVal = ($("#free-shipping-val").val()) * 100;
    var countDownFreeShipping = freeShippingVal - d.items_subtotal_price;
 
    if( countDownFreeShipping > 0 ){
      var formatCountDown = theme.Currency.formatMoney(countDownFreeShipping, theme.moneyFormat);
      $(".freeshiping-countdown").html( "You are <span>"+formatCountDown+"</span> away from receiving free shipping." );
    }
    else{
      $(".freeshiping-countdown").html( "Congratulations, you have received free shipping" );
    }
  },
  dataType: 'json'
});
}

$('.save_qt-popup_btn').on('click', function(){
updateQtty();
});

function handleize(text) {
return text.toString().toLowerCase()
           .replace(/\s+/g, '-')           // Replace spaces with -
           .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
           .replace(/\-\-+/g, '-')         // Replace multiple - with single -
           .replace(/^-+/, '')             // Trim - from start of text
           .replace(/-+$/, '');            // Trim - from end of text
}